import http from './http';
import { Promise } from 'es6-promise';
import FileSaver from 'file-saver';

export default class ResourceUtils {
    static fetchAsBlob(url, options = {}) {
        let headers = {};
        if (options.token) {
            headers.Authorization = `bearer ${options.token}`;
        }
        let request = http._ajx(options.method || 'GET', url, options.payload, {
            headers: headers,
            responseType: 'arraybuffer',
            async: options.async
        })

        if (options.async === false) {
            return new Blob([request.response], {
                type: options.contentType
            });
        } else {
            let promise = new Promise((resolve, reject) => {
                request
                .success((dataString, status, res) => {
                    let blob = new Blob([res.response], {
                        type: options.contentType
                    });
                    resolve(blob, status, res);
                })
                .error((err, status, res) => {
                    reject(err, status, res);
                });
            });

            return promise;
        }
    }

    static downloadBlob(blob, options) {
        FileSaver.saveAs(blob, options.fileName);
    }
}



// WEBPACK FOOTER //
// ./web-app/utils/resource-utils.js